<template lang="pug">
section.product__success--section
  .product__success--block
    .product__success--black
      .product__success--item
        h1(v-if='!product.isPlan') Thank you for purchasing {{ product.name }}
        h1(v-if='product.isPlan') Thank you for purchasing the {{ product.name }}
        h2(v-if='!licenseKey && !product.isPlan') Your license key has been emailed to you
        h2(v-if='licenseKey') License Key: {{ licenseKey }}
        h2(v-if='product.isPlan && !product.isPersecond') Your plan will be activated momentarily. Download our apps below and sign in to make use of this plan.
        h2(v-if='product.isPlan && product.isPersecond') Your plan will be activated momentarily. Download our app below and sign in to make use of this plan.

      .btn__group(v-if='!product.isPlan')
        button.btn.btn--purpleLight(@click='goToLink(product.downloadUrl)') Download
        a(v-if='activateUrl' v-bind:href='activateUrl')
          button.btn.btn--white Activate your License
      .btn__group(v-if='product.isPersecond')
        button.btn.btn--purpleLight(@click='goToLink(product.downloadUrl)') Download
    div(v-if='product.isPlan')
      .product__downloads--container(v-for='product in otherProductsObj')
        .product__item--img
          img(:srcset='product.icon')
        .product__item--title
          h2 {{ product.name }}
        .product__item--button
         button.btn.btn--black(v-if='!product.isPlan' @click='goToLink(product.downloadUrl)') Download
         button.btn.btn--black(v-if='product.isPlan' ui-sref='settings.flixel-cloud') View Plan

  .product__success--block
    .product__success--white(v-if='product.video')
      .full__video
        .fluid__video
          iframe(:src='product.video', frameborder='0', allow='autoplay')
      .video__text
        h1 {{ product.name }} tutorial
        p(v-if='!product.isPlan') Watch this tutorial to learn how to create cinemagraphs with {{ product.name }}
        p(v-if='product.isPlan') Watch this tutorial to learn how to create cinemagraphs with the {{ product.name }}

  .product__success--block(v-if='!product.isPlan')
    .product__downloads
      h1 Check out some of the other Flixel products
    .product__downloads--container(v-for='product in otherProductsObj')
      .product__item--img
        img(:srcset='product.icon')
      .product__item--title
        h2 {{ product.name }}
      .product__item--button
       button.btn.btn--black(@click='goToLink(product.downloadUrl)') Download
       button.btn.btn--black(v-if='product.isPlan' @click='goToLink(settings.flixel-cloud)') View Plan
</template>

<script>
import productsService from 'services/products.es6.js';
import accountService from 'services/account.es6.js';

export default {
  name: 'ProductSuccess',
  props: ['productKey', 'otherProducts', 'checkoutHash'],
  data() {
    return {
      isPlan: false,
      product: {},
      otherProductsObj: [],
      licenseKey: '',
      orderEmail: '',
      activateUrl: '',
    };
  },
  created() {
    this.product = productsService.productForKey(this.productKey);
  },
  mounted() {
    $(window).ready(function () {
      $(window).scrollTop(0);
    });
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
    accountService.get().then(function (newAccountInfo) {
      localStorage.setItem('account', newAccountInfo);
    });
    this.assignOtherProducts(this.otherProducts);
    productsService.orderDetails(this.$route.query.checkout, function (data) {
      if (data.order.is_subscription) {
        productsService.conversionTracking(data);
      } else {
        productsService.conversionTracking(data);
        this.licenseKey = productsService.licenseKey(data);
        this.orderEmail = productsService.orderEmail(data);
        this.activateUrl = productsService.activateUrl(this.product.urlScheme, data);
      }
    });
  },
  methods: {
    assignOtherProducts(otherProducts) {
      for (let i = 0; i < otherProducts.length; i++) {
        this.otherProductsObj.push(productsService.productForKey(otherProducts[i]));
      }
    },
    goToLink(link) {
      window.location.href = link;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/products/productSuccess.vue